import { createSlice } from "@reduxjs/toolkit";

const popup = createSlice({
  name: "popup",
  initialState: {
    data: [],
  },
  reducers: {
    getPopup(state, action) {
      state.data.push(action.payload);
    },
    hidePopup(state) {
      state.data.shift();
    },
  },
});

export const { getPopup, hidePopup } = popup.actions;
export default popup.reducer;
